import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField
} from '@material-ui/core';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { observer } from 'mobx-react';
import { SportDTO } from 'screens/liveScoring/DTO';
import { stores } from 'mobx-store';

interface AddEditSportModalProps {
  open: boolean;
  onClose: () => void;
  sport: SportDTO | null;
}

const validationSchema = Yup.object().shape({
  name: Yup.string().required('Name is required'),
  nameShort: Yup.string().required('Short Name is required')
});

const AddEditSportModal: React.FC<AddEditSportModalProps> = observer(
  ({ open, onClose, sport }) => {
    const { liveScoringStore } = stores;

    const handleSubmit = async (values: SportDTO) => {
      try {
        if (sport?.id) {
          await liveScoringStore.updateSport(sport.id, values);
        } else {
          await liveScoringStore.createSport(values);
        }
        onClose();
      } catch (error) {
        console.error('Error submitting form:', error);
      }
    };

    return (
      <Dialog open={open} onClose={onClose}>
        <DialogTitle>{sport ? 'Edit Sport' : 'Add New Sport'}</DialogTitle>
        <Formik
          initialValues={sport || { name: '', nameShort: '' }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ errors, touched, isSubmitting }) => (
            <Form>
              <DialogContent>
                <Field
                  as={TextField}
                  name="name"
                  label="Name"
                  fullWidth
                  margin="normal"
                  error={touched.name && !!errors.name}
                  helperText={touched.name && errors.name}
                />
                <Field
                  as={TextField}
                  name="nameShort"
                  label="Short Name"
                  fullWidth
                  margin="normal"
                  error={touched.nameShort && !!errors.nameShort}
                  helperText={touched.nameShort && errors.nameShort}
                />
              </DialogContent>
              <DialogActions>
                <Button onClick={onClose} color="secondary">
                  Cancel
                </Button>
                <Button type="submit" color="primary" disabled={isSubmitting}>
                  {isSubmitting ? 'Saving...' : 'Save'}
                </Button>
              </DialogActions>
            </Form>
          )}
        </Formik>
      </Dialog>
    );
  }
);

export default AddEditSportModal;